import { getWatchFieldName } from "./form.service";

export const getDummyFields = (components) => {
  const panels = components.filter((component) => component?.type === "panel");
  return panels.flatMap((panel) => {
    if (Array.isArray(panel.components)) {
      return panel.components.filter(
        (component) => component?.type === "textfield"
      );
    }
    return [];
  });
};

export const getTabItems = (form) => {
  const { components = [] } = form || {};
  if (!Array.isArray(components) || !components.length) return [];
  return components.filter((item) => item && item.components);
};

export const getTabControllingKeys = (tabItems) => {
  if (!tabItems.length) return [];
  const list = tabItems
    .filter((tab) => tab.conditional && tab.conditional.when)
    .flatMap((item) =>
      item.validate ? getWatchFieldName(item) : item.conditional.when
    );
  return [...new Set(list)];
};

export const mergeDgRecordsToMainForm = (props) => {
  const { methodRefs, getDgState, setValue } = props;
  const { dgKeys, ...rest } = getDgState();
  let updatedDg = [];
  if (dgKeys && dgKeys.length) {
    dgKeys.forEach((key) => {
      if (rest[key] && rest[key].length) {
        rest[key].forEach((record) => {
          if (methodRefs && methodRefs[`${key}${record.id}`]) {
            const dataGridFormMethods = methodRefs[`${key}${record.id}`];
            updatedDg.push(dataGridFormMethods.getValues());
          }
        });
      }
      if (updatedDg.length) {
        updatedDg.forEach((record, recordIndex) =>
          setValue(`${key}.${recordIndex}`, record)
        );
        updatedDg = [];
      }
    });
  }
};
